export default function(destination, source) {
  destination = destination || {};
  var value, property;
  if (!source) {
    return destination;
  }
  for (property in source) {
    value = source[property];
    if (value !== undefined) {
      destination[property] = value;
    }
  }
  return destination;
}



//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/extend.js
// module id = zevH
// module chunks = 0